// ---------------------- Bank Card Icons -------------------------------

export enum BankCardPaymentNetworkIcon {
  Visa = "fab fa-cc-visa",
  Mastercard = "fab fa-cc-mastercard",
  Amex = "fab fa-cc-amex",
  Default = "far fa-credit-card"
}
